import { Grid, Paper, Switch, withStyles } from "@material-ui/core";
import { grey, teal } from "@material-ui/core/colors";
import {
  InputFileCustom,
  InputOptionMaster,
  InputReactDatepicker,
  InputTextArea,
  InputTextMaster,
  MasterButton,
} from "App/Component/ui";
import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  TYPE_INSTANCE1,
  instance1,
} from "App/constants";
import {
  defaultToastError,
  defaultToastSuccess,
  fetchData,
  formatRupiah,
  isNull,
} from "App/utils/helpers";
import React, { useEffect, useRef, useState } from "react";
import { LIST_URL_MASTER } from "utils/masters";
import { valueClassHospital, valueTypeHospital } from "./helpers";

function FormHospital({ formData, setFormData, photo, setPhoto, fetchDataForm }) {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);
  const logoRef = useRef();

  useEffect(() => {
    (async () => {
      if (!isNull(photo)) {
        logoRef.current.src = URL.createObjectURL(photo);
        logoRef.current.onLoad = function () {
          URL.revokeObjectURL(URL.createObjectURL(photo));
        };
      }
    })();
  }, [photo]);

  const updateHospital = () => {
    return instance1.post(
      LIST_URL_MASTER.rumah_sakit.update,
      {
        ...formData,
        image: photo,
      },
      {
        headers: {
          idhospital: formData.id,
        },
      }
    );
  };

  const addHospital = async () => {
    return instance1.post("/hospital/addhospital", {
      ...formData,
      image: photo,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);

    if (formData.name === "" || formData.code === "") {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError("Nama dan Kode tidak boleh kosong");
    }

    try {
      if (formData.id === "") {
        await addHospital();
      } else if (formData.id !== "") {
        await updateHospital();
      }
      fetchDataForm();
      defaultToastSuccess("Berhasil memperbarui data rumah sakit");
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
    } catch (error) {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError(error?.response?.data?.message);
    }
  };

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    });
  };

  const handleChangeNumber = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: formatRupiah(e.target.value),
    });
  };

  const PurpleSwitch = withStyles({
    switchBase: {
      color: grey[600],
      "&$checked": {
        color: teal[500],
      },
      "&$checked + $track": {
        backgroundColor: teal[500],
      },
    },
    checked: {},
    track: {},
  })(Switch);

  return (
    <>
      <form action="POST" onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={1}>
          <Grid item md={6}>
            <Paper className="p-1">
              <p className="fw-600">KONFIGURASI GENERAL</p>
              <Grid container spacing={1}>
                <InputTextMaster
                  type="hidden"
                  name="id"
                  id="id"
                  readOnly={true}
                  value={formData.id}
                />

                <Grid item sm={12} md={4}>
                  <InputTextMaster
                    name="num_code"
                    label="NOMOR KODE RUMAH SAKIT"
                    id="num_code"
                    value={formData.num_code}
                    onChange={handleChange("num_code")}
                    placeholder="Nomor Kode Rumah Sakit"
                  />
                </Grid>
                <Grid item sm={12} md={4}>
                  <InputReactDatepicker
                    isClearable={true}
                    selected={formData.regis_date}
                    label="TANGGAL REGISTRASI"
                    dateFormat="dd/MM/yyyy"
                    withToday={true}
                    placeholderText="Tanggal Registrasi"
                    onChange={(e) => {
                      if (isNull(e)) {
                        setFormData({
                          ...formData,
                          regis_date: e,
                        });
                      } else {
                        setFormData({
                          ...formData,
                          regis_date: e,
                        });
                      }
                    }}
                  />
                </Grid>
                <Grid item sm={12} md={4}>
                  <InputTextMaster
                    name="code"
                    label="KODE INISIAL RUMAH SAKIT"
                    id="code"
                    value={formData.code}
                    onChange={handleChange("code")}
                    placeholder="Kode"
                  />
                </Grid>

                <Grid item sm={12}>
                  <InputTextMaster
                    name="name"
                    label="NAMA"
                    id="name"
                    value={formData.name}
                    onChange={handleChange("name")}
                    placeholder="Nama"
                  />
                </Grid>

                <Grid item sm={12} md={6}>
                  <InputOptionMaster
                    name="type"
                    label="TYPE"
                    id="type"
                    withSearch={false}
                    needParse={false}
                    data={valueTypeHospital}
                    value={formData.type}
                    onChange={handleChange("type")}
                  />
                </Grid>
                <Grid item sm={12} md={6}>
                  <InputOptionMaster
                    name="kelas"
                    label="KELAS"
                    id="keals"
                    withSearch={false}
                    needParse={false}
                    data={valueClassHospital}
                    value={formData.class}
                    onChange={handleChange("class")}
                  />
                </Grid>

                <Grid item sm={12} md={4}>
                  <InputTextMaster
                    name="directors_name"
                    label="NAMA DIREKTUR RS"
                    id="directors_name"
                    value={formData.directors_name}
                    onChange={handleChange("directors_name")}
                    placeholder="Nama Direktur RS"
                  />
                </Grid>
                <Grid item sm={12} md={4}>
                  <InputTextMaster
                    name="organizers_name"
                    label="NAMA PENYELENGGARA RS"
                    id="organizers_name"
                    value={formData.organizers_name}
                    onChange={handleChange("organizers_name")}
                    placeholder="Nama Penyelenggara RS"
                  />
                </Grid>
                <Grid item sm={12} md={4}>
                  <InputTextMaster
                    name="status_penyelenggara_swasta"
                    label="STATUS PENYELENGGARA SWASTA"
                    id="status_penyelenggara_swasta"
                    value={formData.status_penyelenggara_swasta}
                    onChange={handleChange("status_penyelenggara_swasta")}
                    placeholder="Status Penyelenggara Swasta"
                  />
                </Grid>

                <Grid item sm={12}>
                  <p className="fw-600 mt-1 font-sm">ALAMAT/LOKASI RS</p>
                </Grid>
                <Grid item sm={12} md={3}>
                  <InputTextMaster
                    name="city"
                    label="KOTA"
                    id="city"
                    value={formData.city}
                    onChange={handleChange("city")}
                    placeholder="Kota"
                  />
                </Grid>
                <Grid item sm={12} md={3}>
                  <InputTextMaster
                    name="fax"
                    label="FAX"
                    id="fax"
                    value={formData.fax}
                    onChange={handleChange("fax")}
                    placeholder="Fax"
                  />
                </Grid>
                <Grid item sm={12} md={3}>
                  <InputTextMaster
                    name="email"
                    label="EMAIL"
                    id="email"
                    value={formData.email}
                    onChange={handleChange("email")}
                    placeholder="Email"
                  />
                </Grid>
                <Grid item sm={12} md={3}>
                  <InputTextMaster
                    name="no_tlpn"
                    label="TELEPON"
                    id="no_tlpn"
                    value={formData.no_tlpn}
                    onChange={handleChange("no_tlpn")}
                    placeholder="Tlp"
                  />
                </Grid>

                <Grid item sm={12} md={4}>
                  <InputTextMaster
                    name="no_tlpn_w_ext"
                    label="TELEPON EXT"
                    id="no_tlpn_w_ext"
                    value={formData.no_tlpn_w_ext}
                    onChange={handleChange("no_tlpn_w_ext")}
                    placeholder="Tlp Ext"
                  />
                </Grid>
                <Grid item sm={12} md={4}>
                  <InputTextMaster
                    name="postal_code"
                    label="KODE POS"
                    id="postal_code"
                    value={formData.postal_code}
                    onChange={handleChange("postal_code")}
                    placeholder="Kode Pos"
                  />
                </Grid>
                <Grid item sm={12} md={4}>
                  <InputTextMaster
                    name="website"
                    label="WEBSITE"
                    id="website"
                    value={formData.website}
                    onChange={handleChange("website")}
                    placeholder="Website"
                  />
                </Grid>

                <Grid item sm={12}>
                  <InputTextArea
                    label={"Alamat"}
                    placeholder={"Alamat"}
                    name="address"
                    value={formData.address}
                    onChange={handleChange("address")}
                    id="address"
                    rows={"3"}
                  />
                </Grid>

                <Grid item sm={12}>
                  <p className="fw-600 mt-1 font-sm">LUAS RUMAH SAKIT</p>
                </Grid>
                <Grid item sm={12} md={6}>
                  <InputTextMaster
                    name="land_area"
                    label="LUAS TANAH"
                    id="land_area"
                    value={formData.land_area}
                    onChange={handleChangeNumber("land_area")}
                    placeholder="Luas Tanah"
                  />
                </Grid>
                <Grid item sm={12} md={6}>
                  <InputTextMaster
                    name="building_area"
                    label="LUAS BANGUNAN"
                    id="building_area"
                    value={formData.building_area}
                    onChange={handleChangeNumber("building_area")}
                    placeholder="Luas Bangunan"
                  />
                </Grid>

                <Grid item sm={12}>
                  <p className="fw-600 mt-1 font-sm">SURAT IZIN/PENETAPAN</p>
                </Grid>
                <Grid item sm={12} md={4}>
                  <InputTextMaster
                    name="licensing_num"
                    label="NOMOR"
                    id="licensing_num"
                    value={formData.licensing_num}
                    onChange={handleChange("licensing_num")}
                    placeholder="Nomor"
                  />
                </Grid>
                <Grid item sm={12} md={4}>
                  <InputReactDatepicker
                    isClearable={true}
                    selected={formData.licensing_date}
                    label="TANGGAL"
                    dateFormat="dd/MM/yyyy"
                    withToday={true}
                    placeholderText="Tanggal"
                    onChange={(e) => {
                      if (isNull(e)) {
                        setFormData({
                          ...formData,
                          licensing_date: e,
                        });
                      } else {
                        setFormData({
                          ...formData,
                          licensing_date: e,
                        });
                      }
                    }}
                  />
                </Grid>
                <Grid item sm={12} md={4}>
                  <InputTextMaster
                    name="licensing_issued_by"
                    label="OLEH"
                    id="licensing_issued_by"
                    value={formData.licensing_issued_by}
                    onChange={handleChange("licensing_issued_by")}
                    placeholder="Oleh"
                  />
                </Grid>

                <Grid item sm={12}>
                  <p className="fw-600 mt-1 font-sm">AKREDITASI RS</p>
                </Grid>
                <Grid item sm={12} md={4}>
                  <InputTextMaster
                    name="akreditasi_pentahapan"
                    label="PENETAHAPAN"
                    id="akreditasi_pentahapan"
                    value={formData.akreditasi_pentahapan}
                    onChange={handleChange("akreditasi_pentahapan")}
                    placeholder="Pentahapan"
                  />
                </Grid>
                <Grid item sm={12} md={4}>
                  <InputTextMaster
                    name="akreditasi_status"
                    label="STATUS AKREDITASI"
                    id="akreditasi_status"
                    value={formData.akreditasi_status}
                    onChange={handleChange("akreditasi_status")}
                    placeholder="Status Akreditasi"
                  />
                </Grid>
                <Grid item sm={12} md={4}>
                  <InputReactDatepicker
                    isClearable={true}
                    selected={formData.akreditasi_date}
                    label="TANGGAL AKREDITASI"
                    dateFormat="dd/MM/yyyy"
                    withToday={true}
                    placeholderText="Tanggal Akreditasi"
                    onChange={(e) => {
                      if (isNull(e)) {
                        setFormData({
                          ...formData,
                          akreditasi_date: e,
                        });
                      } else {
                        setFormData({
                          ...formData,
                          akreditasi_date: e,
                        });
                      }
                    }}
                  />
                </Grid>

                <Grid item sm={12}>
                  <p className="fw-600 mt-1">KONFIGURASI DOKTER MOBILE</p>
                  <Grid container spacing={1}>
                    <Grid item sm={12}>
                      <InputTextMaster
                        name="period_booking"
                        label="PERIODE BOOKING"
                        id="period_booking"
                        value={formData.period_booking}
                        onChange={handleChangeNumber("period_booking")}
                        placeholder="Default 14"
                        withButton={true}
                      >
                        <button
                          type={"button"}
                          onClick={null}
                          style={{
                            borderRight: "1px solid #EAEAEA",
                            borderTop: "1px solid #EAEAEA",
                            borderBottom: "1px solid #EAEAEA",
                            borderLeft: "0",
                            background: "#fff",
                            padding: "0 0.8rem",
                            cursor: "pointer",
                            borderRadius: "0 6px 6px 0",
                          }}
                        >
                          Hari
                        </button>
                      </InputTextMaster>
                    </Grid>
                    <Grid item sm={12}>
                      <Grid container spacing={1}>
                        <Grid item md={11} sm={10}>
                          <span>FILTER DOKTER</span>
                        </Grid>
                        <Grid item md={1} sm={2}>
                          <PurpleSwitch
                            checked={formData.is_filter}
                            onChange={() =>
                              setFormData({
                                ...formData,
                                is_filter: !formData.is_filter,
                              })
                            }
                            name="checkedA"
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
          <Grid item md={6}>
            <Paper className="p-1">
              <Grid container spacing={1}>
                <Grid item sm={12}>
                  <p className="fw-600" style={{ marginBottom: "5px" }}>
                    KONFIGURASI LOGO UTAMA
                  </p>
                  <Grid container spacing={1}>
                    <Grid
                      item
                      sm={12}
                      id="upload-views"
                      style={{
                        textAlign: "center",
                      }}
                    >
                      <img
                        id="output"
                        ref={logoRef}
                        src={isNull(photo) ? "images/image-default.png" : photo}
                        alt="Logo Utama"
                        className="img-upload-view"
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <label
                        htmlFor="photoLogoUtama"
                        style={{
                          fontWeight: 400,
                          color: "#BDBDBD",
                          fontSize: "11px",
                        }}
                      >
                        Photo
                      </label>
                      <InputFileCustom
                        label={"Upload File"}
                        name={"photoLogoUtama"}
                        id={"photoLogoUtama"}
                        initialNameFile={photo}
                        setFile={setPhoto}
                        accept={".jpg, .jpeg, .png"}
                      />
                      {/* <label
                        style={{
                          position: "absolute",
                          left: "8px",
                          fontWeight: 400,
                          color: "#BDBDBD",
                          fontSize: "11px",
                        }}
                      >
                        *File yang diizinkan .jpg, .jpeg, dan .png; Maksimal
                        file berukuran 2MB
                      </label> */}
                      {/* {!isEmpty(photo) && (
                      <img
                        src={isEmpty(photo) ? photo : photo}
                        alt="Logo Utama"
                        style={{
                          height: "200px",
                        }}
                      />
                    )} */}
                    </Grid>

                    <Grid item sm={12} md={6}>
                      <InputTextMaster
                        name="width"
                        label="LEBAR LOGO"
                        id="width"
                        value={formData.width}
                        onChange={handleChangeNumber("width")}
                        placeholder="Lebar Logo"
                        // disabled
                      />
                    </Grid>

                    <Grid item sm={12} md={6}>
                      <InputTextMaster
                        name="height"
                        label="TINGGI LOGO"
                        id="height"
                        value={formData.height}
                        onChange={handleChangeNumber("height")}
                        placeholder="Tinggi Logo"
                        // disabled
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>

        <Grid
          container
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
        >
          <MasterButton
            className={"mt-1"}
            type="submit"
            color={disabled.color}
            name={disabled.label}
            disabled={disabled.disabled}
            size="md"
          />
        </Grid>
      </form>
    </>
  );
}

export default FormHospital;
